import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: string;
  title: string;
  cover: string;
  rating: number;
  reads: string;
  status: string;
  genres: string[];
  updateDay?: string;
  featured?: boolean;
}

export default function ComicCard({
  id,
  title,
  cover,
  rating,
  reads,
  status,
  genres,
  updateDay,
  featured = false,
}: ComicCardProps) {
  return (
    <Link
      to={`/comic/${id}`}
      className="block group"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[5/7] mb-3">
        <img
          src={cover}
          alt={title}
          title={`${title} - 韩漫在线免费阅读`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent" />
        <div className="absolute top-2.5 left-2.5">
          <span className={`px-2 py-0.5 rounded-full text-[10px] font-medium ${
            status === '连载中' || status === 'ongoing'
              ? 'bg-primary-500 text-background-50'
              : 'bg-foreground-500 text-background-50'
          }`}>
            {status === 'ongoing' ? '连载中' : status}
          </span>
        </div>
        <div className="absolute bottom-2.5 right-2.5 flex items-center gap-1 bg-foreground-950/70 backdrop-blur-sm rounded-full px-2 py-0.5">
          <i className="ri-star-fill text-accent-500 text-[10px]"></i>
          <span className="text-background-50 text-[11px] font-medium">{rating}</span>
        </div>
      </div>

      <h3 className="text-sm font-semibold text-foreground-950 mb-1 group-hover:text-primary-500 transition-colors line-clamp-1">
        {title}
      </h3>

      <div className="flex items-center gap-2 mb-1.5">
        <span className="text-xs text-foreground-500">{reads} 阅读</span>
        <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
        <span className="text-xs text-foreground-500">{genres.slice(0, 2).join('·')}</span>
      </div>

      {featured && (
        <button
          className="w-full whitespace-nowrap mt-2 py-2 rounded-full text-xs font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer text-center block"
          onClick={(e) => {
            e.preventDefault();
            window.REACT_APP_NAVIGATE(`/comic/${id}`);
          }}
        >
          立即阅读
        </button>
      )}

      {!featured && updateDay && (
        <p className="text-[11px] text-foreground-400">{updateDay}</p>
      )}
    </Link>
  );
}